import type { ReactNode } from "react";

interface IconProps {
  className?: string | undefined;
}

function IconFrame({
  children,
  className,
}: IconProps & { children: ReactNode }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      focusable="false"
      viewBox="0 0 24 24"
    >
      {children}
    </svg>
  );
}

export function ArchiveIcon({ className }: IconProps) {
  return (
    <IconFrame className={className}>
      <path d="M5 6.5h14M5 12h14M5 17.5h9" />
    </IconFrame>
  );
}

export function CloudIcon({ className }: IconProps) {
  return (
    <IconFrame className={className}>
      <path d="M7.5 18.5h9.25a4.25 4.25 0 0 0 .54-8.47A6 6 0 0 0 5.8 8.5a4.5 4.5 0 0 0 1.7 10Z" />
      <path d="M12 9.5v6m-2.5-2.5L12 15.5l2.5-2.5" />
    </IconFrame>
  );
}

export function RecoveryIcon({ className }: IconProps) {
  return (
    <IconFrame className={className}>
      <path d="M5.5 8.5V4.75M5.5 4.75h3.75" />
      <path d="M6.15 5.4A8 8 0 1 1 4.3 14" />
      <path d="M12 8v4.5l3 1.75" />
    </IconFrame>
  );
}

export function PlanIcon({ className }: IconProps) {
  return (
    <IconFrame className={className}>
      <path d="M5 5.5h14v13H5z" />
      <path d="M8.5 9h7M8.5 12h7M8.5 15h4" />
    </IconFrame>
  );
}

export function BrowserIcon({ className }: IconProps) {
  return (
    <IconFrame className={className}>
      <path d="M4 5.5h16v13H4zM4 9h16" />
      <path d="M7 7.25h.01M9.5 7.25h.01" />
    </IconFrame>
  );
}
